import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { ReservationRepository } from '../repositories/reservation.respository';

export class UpdateReservationUseCase implements UseCase<any, boolean> {
    constructor(private readonly repository: ReservationRepository) {}

    execute(reservation: any): Observable<boolean> {
        return this.repository.updateReservation(reservation);
    }
}
